import React from "react";

export function ConfidenceBar({ value = 0 }) {
  const pct = Math.round(Math.max(0, Math.min(1, value)) * 100);
  let color = "bg-red-500";
  if (pct >= 80) color = "bg-green-500";
  else if (pct >= 50) color = "bg-amber-500";
  return (
    <div className="h-1 w-full overflow-hidden rounded-full bg-neutral-200 dark:bg-neutral-800">
      <div className={`confidence-fill h-full ${color}`} style={{ width: `${pct}%` }} />
    </div>
  );
}
